import { GridCellProps, GridColumnProps } from '@progress/kendo-react-grid'
import { WalletConfigKey } from 'api/Wallet/Types/WalletConfigDto'
import { booleanFilterCell } from 'components/Filter/FilterCell'
import { WalletTypeFilterCell } from 'components/Filter/WalletFilterCell'

import { CompaniesFilterCell, CountriesFilterCell, CurrenciesFilterCell } from './WalletsFilters'

const BooleanFilterCell = booleanFilterCell({
  options: {
    operator: '==',
  },
})

export interface GridColumn extends GridColumnProps {
  show: boolean
  width?: number
}

const walletColumns: GridColumn[] = [
  {
    title: 'Tickmill Entity',
    field: WalletConfigKey.tickmillCompany,
    filterCell: CompaniesFilterCell,
    sortable: false,
    cell: (props: GridCellProps): JSX.Element => {
      if (!props.dataItem?.tickmillCompany?.name) {
        return <td />
      }

      return <td>{props.dataItem.tickmillCompany.name}</td>
    },
    show: true,
  },
  {
    title: 'Country',
    field: WalletConfigKey.country,
    filterCell: CountriesFilterCell,
    show: true,
    sortable: false,
  },
  {
    title: 'Wallet Type',
    field: WalletConfigKey.walletType,
    filterCell: WalletTypeFilterCell,
    show: true,
    sortable: false,
  },
  {
    title: 'Currency',
    field: WalletConfigKey.currency,
    filterCell: CurrenciesFilterCell,
    show: true,
    sortable: false,
  },
  {
    title: 'Is Default',
    field: WalletConfigKey.isDefault,
    filterCell: BooleanFilterCell,
    cell: (props: GridCellProps): JSX.Element => {
      return (
        <td align='center' style={{ textAlign: 'center' }}>
          <input type='checkbox' checked={props.dataItem.isDefault} disabled />
        </td>
      )
    },
    width: 180,
    minResizableWidth: 180,
    show: true,
    sortable: false,
  },
  {
    title: 'Is Internal',
    field: WalletConfigKey.isInternal,
    filterCell: BooleanFilterCell,
    cell: (props: GridCellProps): JSX.Element => {
      return (
        <td align='center' style={{ textAlign: 'center' }}>
          <input type='checkbox' checked={props.dataItem.isInternal} disabled />
        </td>
      )
    },
    width: 180,
    minResizableWidth: 180,
    show: true,
    sortable: false,
  },
]

export default walletColumns
